<script setup>
import { onMounted, onUnmounted, getCurrentInstance, computed } from "vue";
import { subscribeToAlertTopic, unsubscribeFromAlertTopic } from "@/mqtt/mqttService";
import { useStore } from "vuex";

import StoreDialog from './components/StoreDialog.vue';

const store = useStore();
const { proxy } = getCurrentInstance();

const enterpriseName = computed(() => {
  return store.state.user ? store.state.user.user_enterprise : null;
});

onUnmounted(() => {
  unsubscribeFromAlertTopic();
});

</script>

<template>
  <div id="app">
    <GlobalAlert />
    <StoreDialog></StoreDialog>
    <router-view />
  </div>
</template>
